var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconStick24Line = function SvgIconStick24Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.148 19.795v-6.1h1.7v6.1h-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.374 4.44c0-.47.38-.85.85-.85h5.55c.47 0 .85.38.85.85v6.127l1.851 2.64a.85.85 0 0 1-.696 1.338H7.22a.85.85 0 0 1-.696-1.338l1.851-2.64V4.44Zm1.7.85v5.545a.85.85 0 0 1-.154.488l-1.067 1.522h6.292l-1.067-1.522a.85.85 0 0 1-.154-.488V5.29h-3.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.78 5.29H7.22v-1.7h9.56v1.7Z"
  }))));
};
export default SvgIconStick24Line;